/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import { getPortfolioProjectPublishDialogTranslations } from 'bundles/portfolio-projects/constants';
import EVENTS from 'bundles/portfolio-projects/events';

export type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onPublish: () => void;
};

const styles = {
  buttonGroup: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
};

const PortfolioProjectPublishDialog = ({ open, onClose, onPublish, loading = false }: Props) => {
  const { Actions, Content, HeadingGroup } = Dialog;
  const {
    PORTFOLIO_PROJECT_PUBLISH_DIALOG_TITLE,
    PORTFOLIO_PROJECT_PUBLISH_DIALOG_DESCRIPTION,
    PORTFOLIO_PROJECT_PUBLISH_DIALOG_CANCEL_LABEL,
    PORTFOLIO_PROJECT_PUBLISH_DIALOG_PUBLISH_LABEL,
  } = getPortfolioProjectPublishDialogTranslations();

  return (
    <Dialog open={open} onClose={onClose}>
      <HeadingGroup title={PORTFOLIO_PROJECT_PUBLISH_DIALOG_TITLE}>
        {PORTFOLIO_PROJECT_PUBLISH_DIALOG_TITLE}
      </HeadingGroup>

      <Content>
        <Typography2 component="p" color="supportText">
          {PORTFOLIO_PROJECT_PUBLISH_DIALOG_DESCRIPTION}
        </Typography2>
      </Content>

      <Actions css={styles.buttonGroup}>
        <Button
          variant="primary"
          size="medium"
          loading={loading}
          onClick={onPublish}
          component={TrackedButton}
          withVisibilityTracking
          requireFullyVisible
          trackingName={EVENTS.portfolioBuilderPublishConfirmation}
        >
          {PORTFOLIO_PROJECT_PUBLISH_DIALOG_PUBLISH_LABEL}
        </Button>
        <Button variant="secondary" size="medium" disabled={loading} onClick={onClose}>
          {PORTFOLIO_PROJECT_PUBLISH_DIALOG_CANCEL_LABEL}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default PortfolioProjectPublishDialog;
